import { ApplicationNames } from '@ddt-web/domain';

/**
 * User Preferences should be used to persist user selections values.
 * These values should be used ONLY as defaults/fallback values.
 */
export enum UserPreferencesProps {
	CURRENCY = 'currency',
	BENCHMARK = 'benchmark',
	IS_GETTING_STARTED_SECTION_CLOSED = 'isGettingStartedSectionClosed',
	DELIMITER = 'delimiter',
	ANALYSIS_GROUPS = 'analysisGroups'
}

export interface UserPreferences {
	[UserPreferencesProps.CURRENCY]?: string;
	[UserPreferencesProps.BENCHMARK]?: string;
	[UserPreferencesProps.IS_GETTING_STARTED_SECTION_CLOSED]?: boolean;
	[UserPreferencesProps.DELIMITER]?: string;
	[UserPreferencesProps.ANALYSIS_GROUPS]?: string;
}

export enum UserPreferencesKeys {
	NILE = 'USER_PREFERENCE_nile',
	BFA = 'USER_PREFERENCE_bfa',
	BPAS = 'USER_PREFERENCE_bpas'
}

export const USER_PREFERENCES_PROPERTIES: UserPreferencesProps[] = Object.keys(UserPreferencesProps).map(k => UserPreferencesProps[k]);

export const APPLICATION_TO_PREFERENCE_KEY_MAP: Map<ApplicationNames, UserPreferencesKeys> = new Map([
	[ApplicationNames.PORTFOLIO_CENTRE, UserPreferencesKeys.NILE],
	[ApplicationNames.PORTFOLIO_CENTRE_360, UserPreferencesKeys.NILE],
	[ApplicationNames.DASHBOARD, UserPreferencesKeys.BFA],
	[ApplicationNames.PORTFOLIO_ANALYSER, UserPreferencesKeys.BFA],
	[ApplicationNames.CMA_ESTIMATOR, UserPreferencesKeys.BFA],
	[ApplicationNames.SCENARIO_TESTER, UserPreferencesKeys.BFA],
	[ApplicationNames.MY_SAVED_PORTFOLIOS, UserPreferencesKeys.BFA],
	[ApplicationNames.TAX_ESTIMATOR, UserPreferencesKeys.BFA],
	[ApplicationNames.INVESTMENT_QUALITY, UserPreferencesKeys.BFA],
	[ApplicationNames.IRETIRE_ACCUM, UserPreferencesKeys.BFA],
	[ApplicationNames.IRETIRE_DECUM, UserPreferencesKeys.BFA],
	[ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION, UserPreferencesKeys.BPAS],
	[ApplicationNames.PROFESSIONAL_INVESTORS, UserPreferencesKeys.BFA],
	[ApplicationNames.AC_PORTFOLIO_LIBRARY, UserPreferencesKeys.BFA]
]);
